<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Proforma megrendelések</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/sales/proform-customer-orders/add')"
        icon="el-icon-plus"
        v-can="'proformcustomerorder.create'"
      >
        Új proforma megrendelés
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="proformCustomerOrder/fetchAll"
      />
    </div>
    <proform-customer-order-list/>
    <template v-if="$route.meta.showAddProformCustomerOrderDialog">
      <proform-customer-order-dialog
        type="add"
        :proform-customer-order-id="$route.params.id"
      />
    </template>
    <template v-if="$route.meta.showUpdateProformCustomerOrderDialog">
      <proform-customer-order-dialog
        :proform-customer-order-id="$route.params.id"
        type="update"
      />
    </template>
    <template v-if="$route.meta.showProformCustomerOrderViewDialog">
      <proform-customer-order-dialog
        :proform-customer-order-id="$route.params.id"
        type="view"
      />
    </template>
  </el-card>
</template>

<script>
import proformCustomerOrderList from '../../components/sales/proformCustomerOrders/List';
import proformCustomerOrderDialog from '../../components/sales/proformCustomerOrders/Dialog';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    proformCustomerOrderList,
    proformCustomerOrderDialog,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async setConfig() {
      this.filterConfig = [
        {
          type: 'text',
          name: 'receipt_number',
          label: 'Bizonylatszám',
          defaultSearch: true,
        },
        {
          type: 'date',
          name: 'created_at',
          label: 'Rögzítés dátuma',
        },
        {
          type: 'date',
          name: 'delivery_date',
          label: 'Szállítás dátuma',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Rögzítve',
              status: 'recorded'
            },
            {
              label: 'Fizetésre vár',
              status: 'waiting-for-payee'
            },
            {
              label: 'Teljesítve',
              status: 'done'
            },
            {
              label: 'Érvénytelenítve',
              status: 'cancelled'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'remote',
          name: 'customer_id',
          label: 'Vevő',
          labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'partner/search',
        },
      ];
    },
  },
};
</script>
